<template>
    <div v-html="skyscrapperBanner"></div>
</template>


<script>

    export default {
        name: 'skyscrapperBanner',
        data() {
            return {
                skyscrapperBanner: null
            }
        },
        mounted() {

            this.axios.get(this.$store.state.SkyscraperBannerNetworkHTMLCodeApi).then((response) => {
                this.skyscrapperBanner = response.data.HTMLCode;
            }).catch((error) => { })

        }
    }
</script>